export const ACTION_BUTTON_SIZE_CLASSES = {
  cvent: {
    base: 'size-5',
    medium: 'size-6',
    large: 'size-7'
  },
  goldcast: {
    base: 'size-4',
    medium: 'size-5',
    large: 'size-6'
  }
};
